// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-smallOnWide-superElipse-2a672cff","strokeWidth":"super-ellipse-skins-smallOnWide-strokeWidth-8abbb74c"};